<template lang="pug">
.view-platforms.content
  ui-navbar-panel(title="Общая статистика")

  //div.columns
  //  .column.is-4-desktop
  //    table.table(v-if="!isLoading")
  //      tbody
  //        tr
  //          td Активные задачи
  //          td {{ data.helpdesk.active_count }}
  //        tr
  //          td
  //            span.pl-3 На тестировании
  //          td {{ data.helpdesk.testing_count }}
  //        tr
  //          td Активные ошибки
  //          td {{ data.helpdesk.active_bugs_count }}
  //        tr
  //          td Ожидают ответ более суток
  //          td
  //            span(:class="'is-light ' + (data.helpdesk.warning_wait_count ? 'has-text-danger' : '')") {{ data.helpdesk.warning_wait_count }}
  //        tr
  //          td Не закрыты более двух недель
  //          td
  //            span(:class="'is-light ' + (data.helpdesk.warning_active_count ? 'has-text-danger' : '')") {{ data.helpdesk.warning_active_count }}

</template>

<script>
import api from '@/api';

export default {
  name: 'view-common-stat',

  data: () => ({
    data: {
      helpdesk: {
        active_count: 0,
        warning_active_count: 0,
        warning_wait_count: 0,
        active_bugs_count: 0,
        testing_count: 0,
      }
    },
    isLoading: true,
  }),

  methods: {
    loadHelpdeskStat() {
      // api
      //   .for('helpdesk')
      //   .read('stat/common')
      //   .then(({ data }) => {
      //     this.data = data;
      //     this.isLoading = false;
      //   });
    },
  },

  created() {
    this.loadHelpdeskStat();
  },
};
</script>
